import { cn } from '../lib/utils'

import ItemCardSkeleton from './ItemCardSkeleton'
import Skeleton from './Skeleton'

/**
 * Exact-layout placeholder for the Items in Cart / Recently Browsed sections
 * (RP-5936 prototype geometry): the heading bar (148×20 in the 28px line box)
 * plus two item rows.
 *
 * Defined once and rendered from three places — the two sections while their
 * own data is pending, and the Hub's boot screen, which paints the tab's
 * placeholders before the sections can mount. Keeping one definition is what
 * stops the boot screen and the sections drifting apart.
 */
export default function ItemsSectionSkeleton({
  testId,
  isReserved,
}: {
  testId: string
  /** Reserve the layout without painting it (the anti-flash window). */
  isReserved?: boolean
}) {
  return (
    <section
      className={cn(
        'flex flex-col gap-16 max-lg:px-16',
        isReserved && 'invisible',
      )}
      aria-busy="true"
      data-testid={testId}
    >
      <Skeleton w={148} h={20} className="my-4" />
      <div className="flex flex-col gap-16">
        <ItemCardSkeleton />
        <ItemCardSkeleton />
      </div>
    </section>
  )
}
